import { Component } from 'react';
import { Head } from 'head/Head';
import { Typography } from 'omakase';
import Anchor from 'components/Anchor';

interface Props {
  staticContext: {
    status: number;
  };
}

export default class NotFoundRoute extends Component<Props> {
  render() {
    // Used for server side redirect.
    if (this.props.staticContext) {
      this.props.staticContext.status = 404;
    }

    return (
      <>
        <Head title="Not Found" />
        <div className="NotFound">
          <div className="SectionWrapper">
            <h1 className="NotFound-heading">
              <Typography component="span" variant="heading02">
                Oops, page not found
              </Typography>
            </h1>
            <h2 className="NotFound-subheading">
              <Typography color="inherit" component="span" variant="body02">
                You may have mistyped the address or the page may have moved.
              </Typography>
            </h2>
            <div className="NotFound-link">
              <Anchor href="/">
                <Typography color="inherit" component="span" variant="body02">
                  Go to Tock homepage
                </Typography>
              </Anchor>
            </div>
          </div>
        </div>
      </>
    );
  }
}
